module.exports = __webpack_public_path__ + "img/q26.75e39741.png";